import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography, TextField } from "@mui/material";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";

function DeliveryNumberField({
  deliveryNumber,
  setDeliveryNumber,
  onCalcFromTargetClearCount,
}: {
  deliveryNumber: number;
  setDeliveryNumber: React.Dispatch<React.SetStateAction<number>>;
  onCalcFromTargetClearCount: () => void;
}) {
  const { t } = useTranslation("questEditor");

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <TextField
        type="number"
        size="small"
        value={deliveryNumber}
        onChange={(e) => setDeliveryNumber(Number(e.target.value))}
        inputProps={{ min: 0 }}
        sx={{ width: 120 }}
      />
      <Typography color="primary">
        {t(
          "quest_edit_target.field.number_of_deliveries.number_of_deliveries_label",
        )}
      </Typography>
      <SubActionButton
        onClick={onCalcFromTargetClearCount}
      >
        {t("quest_edit_target.button.calc_by_target_clear_count")}
      </SubActionButton>
    </Stack>
  );
}

export default DeliveryNumberField;
